<div
  class="pdf-drop"
  [class.open]="open"
  [class.drag-active]="dragActive"
  (click)="onBackdropClick($event)"
>
  <div class="pdf-drop-stage">
    <button class="pdf-drop-close" type="button" aria-label="Close" (click)="onCloseClick()">
      <svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>
    </button>
    <h1 class="pdf-drop-title">Drop your research PDF</h1>
    <p class="pdf-drop-sub">Cimalti will extract investment views, holdings, and performance — ready to apply to your portfolios.</p>

    <div class="pdf-drop-deck">

      <div class="pdf-peek-card gavekal" style="--fan:-18deg; --off:-380px;">
        <div class="pc-mast">
          <div class="pc-brand-block">
            <span class="pc-brand">GAVEKAL</span>
            <span class="pc-pub">RESEARCH</span>
          </div>
          <span class="pc-pg">Q2 · p.11</span>
        </div>
        <div class="pc-rule"></div>
        <div class="pc-doc-title">The Bond-Free Portfolio</div>
        <div class="pc-byline">Louis-Vincent Gave · Apr 15, 2026</div>
        <div class="pc-chart">
          <div class="pc-chart-meta"><span>NVDA · 3Y TOTAL RETURN</span><b class="pos">+142%</b></div>
          <svg viewBox="0 0 120 40" preserveAspectRatio="none" class="pc-chart-svg">
            <defs><linearGradient id="gv-g" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#00E5A0" stop-opacity="0.35"/><stop offset="100%" stop-color="#00E5A0" stop-opacity="0"/></linearGradient></defs>
            <path d="M0 32 L12 30 L24 28 L36 30 L48 24 L60 20 L72 16 L84 11 L96 8 L108 5 L120 2 L120 40 L0 40 Z" fill="url(#gv-g)"/>
            <path d="M0 32 L12 30 L24 28 L36 30 L48 24 L60 20 L72 16 L84 11 L96 8 L108 5 L120 2" fill="none" stroke="#00E5A0" stroke-width="1.4"/>
          </svg>
          <div class="pc-chart-axis"><span>'23</span><span>'24</span><span>'25</span><span>'26</span></div>
        </div>
        <div class="pc-body"><div class="pc-para w95"></div><div class="pc-para w80"></div></div>
        <div class="pc-quote">"Reiterate strong conviction long on <b>NVDA</b> — <span class="pos">+18%</span>."</div>
        <div class="pc-foot-doc"><span>GAVEKAL · CONFIDENTIAL</span><span>11 / 42</span></div>
      </div>

      <div class="pdf-peek-card bloomberg" style="--fan:-8deg; --off:-190px;">
        <div class="pc-mast">
          <div class="pc-brand-block">
            <span class="pc-brand">BLOOMBERG</span>
            <span class="pc-pub">INTELLIGENCE</span>
          </div>
          <span class="pc-pg">SECTOR · p.06</span>
        </div>
        <div class="pc-rule"></div>
        <div class="pc-doc-title">AI Infrastructure: From Hype to Cashflow</div>
        <div class="pc-byline">Mandeep Singh · Apr 8, 2026</div>
        <div class="pc-chart">
          <div class="pc-chart-meta"><span>AI CAPEX · $B Q/Q</span><b class="pos">+28%</b></div>
          <svg viewBox="0 0 120 40" preserveAspectRatio="none" class="pc-chart-svg">
            <rect x="2"   y="26" width="10" height="14" fill="#FFB547" opacity="0.55"/>
            <rect x="16"  y="22" width="10" height="18" fill="#FFB547" opacity="0.65"/>
            <rect x="30"  y="18" width="10" height="22" fill="#FFB547" opacity="0.75"/>
            <rect x="44"  y="14" width="10" height="26" fill="#FFB547" opacity="0.80"/>
            <rect x="58"  y="10" width="10" height="30" fill="#FFB547" opacity="0.85"/>
            <rect x="72"  y="7"  width="10" height="33" fill="#FFB547" opacity="0.90"/>
            <rect x="86"  y="4"  width="10" height="36" fill="#FFB547"/>
            <rect x="100" y="2"  width="10" height="38" fill="#FFB547"/>
          </svg>
          <div class="pc-chart-axis"><span>Q1</span><span>Q2</span><span>Q3</span><span>Q4</span></div>
        </div>
        <div class="pc-table">
          <div class="pc-trow"><span>NVDA</span><b class="pos">+22%</b></div>
          <div class="pc-trow"><span>AMZN</span><b class="pos">+14%</b></div>
          <div class="pc-trow"><span>SMH</span><b class="pos">+6%</b></div>
        </div>
        <div class="pc-foot-doc"><span>BI · INTERNAL</span><span>06 / 28</span></div>
      </div>

      <div class="pdf-drop-zone" (click)="onZoneClick()">
        <div class="pdf-drop-zone-ic">
          <svg viewBox="0 0 24 24"><path d="M6 3h9l4 4v14H6z" stroke-linejoin="round"/><path d="M15 3v4h4"/><path d="M9 13h6M9 16h4M9 19h6" stroke-linecap="round"/></svg>
        </div>
        <h3>Drop file here</h3>
        <p>or <span class="lnk">browse files</span></p>
        <input
          #fileInput
          type="file"
          accept="application/pdf,.csv,.xls,.xlsx,.docx"
          hidden
          (change)="onFileChange($event)"
        />
        <div class="pdf-tip">PDF · DOCX · CSV · XLSX — up to 50MB</div>
      </div>

      <div class="pdf-peek-card bofa" style="--fan:8deg; --off:190px;">
        <div class="pc-mast">
          <div class="pc-brand-block">
            <span class="pc-brand">BofA</span>
            <span class="pc-pub">GLOBAL RESEARCH</span>
          </div>
          <span class="pc-pg">EUROPE · p.05</span>
        </div>
        <div class="pc-rule"></div>
        <div class="pc-doc-title">European Defensives: A Late-Cycle Hedge</div>
        <div class="pc-byline">Sebastian Raedler · Mar 22, 2026</div>
        <div class="pc-chart">
          <div class="pc-chart-meta"><span>STOXX 600 DEFENSIVES</span><b class="pos">+8.4%</b></div>
          <svg viewBox="0 0 120 40" preserveAspectRatio="none" class="pc-chart-svg">
            <path d="M0 28 L15 30 L30 24 L45 26 L60 18 L75 22 L90 14 L105 12 L120 8" fill="none" stroke="#FF5C7A" stroke-width="1.4"/>
            <path d="M0 22 L15 20 L30 18 L45 20 L60 16 L75 17 L90 12 L105 10 L120 6" fill="none" stroke="#FF5C7A" stroke-width="1" stroke-dasharray="2 2" opacity="0.6"/>
            <circle cx="120" cy="8" r="2.2" fill="#FF5C7A"/>
          </svg>
          <div class="pc-chart-axis"><span>Jan</span><span>Feb</span><span>Mar</span><span>YTD</span></div>
        </div>
        <div class="pc-body"><div class="pc-para w90"></div><div class="pc-para w75"></div></div>
        <div class="pc-quote">"Nestlé valuation at 10-yr low — long <span class="pos">+8%</span>."</div>
        <div class="pc-foot-doc"><span>BofA GLOBAL RESEARCH</span><span>05 / 19</span></div>
      </div>

      <div class="pdf-peek-card jpm" style="--fan:18deg; --off:380px;">
        <div class="pc-mast">
          <div class="pc-brand-block">
            <span class="pc-brand">J.P.MORGAN</span>
            <span class="pc-pub">EM STRATEGY</span>
          </div>
          <span class="pc-pg">FI · p.14</span>
        </div>
        <div class="pc-rule"></div>
        <div class="pc-doc-title">EM Local FI: The Dollar-Peak Trade</div>
        <div class="pc-byline">Saad Siddiqui · Feb 11, 2026</div>
        <div class="pc-chart">
          <div class="pc-chart-meta"><span>DXY INDEX · 12M</span><b class="neg">-4.2%</b></div>
          <svg viewBox="0 0 120 40" preserveAspectRatio="none" class="pc-chart-svg">
            <defs><linearGradient id="jpm-g" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#54C7FF" stop-opacity="0.30"/><stop offset="100%" stop-color="#54C7FF" stop-opacity="0"/></linearGradient></defs>
            <path d="M0 6 L12 8 L24 10 L36 14 L48 12 L60 18 L72 22 L84 24 L96 28 L108 26 L120 32 L120 40 L0 40 Z" fill="url(#jpm-g)"/>
            <path d="M0 6 L12 8 L24 10 L36 14 L48 12 L60 18 L72 22 L84 24 L96 28 L108 26 L120 32" fill="none" stroke="#54C7FF" stroke-width="1.4"/>
          </svg>
          <div class="pc-chart-axis"><span>'25</span><span>Q2</span><span>Q3</span><span>'26</span></div>
        </div>
        <div class="pc-table">
          <div class="pc-trow"><span>EMLC</span><b class="pos">+10%</b></div>
          <div class="pc-trow"><span>EMB</span><b class="pos">+6%</b></div>
          <div class="pc-trow"><span>DXY</span><b class="neg">-4%</b></div>
        </div>
        <div class="pc-foot-doc"><span>J.P. MORGAN RESEARCH</span><span>14 / 34</span></div>
      </div>

    </div>

    <div class="pdf-drop-hint">
      Drag a PDF here from Finder or email — or click the zone to browse
    </div>
  </div>
</div>
